import { useEffect, useState } from 'react';

/**
 * Tracks whether the page's web fonts have finished loading, using the
 * Font Loading API. Useful for gating aggressive letter-spacing tuned for a
 * custom font so the fallback font doesn't render with overlapping glyphs
 * while the real font is still loading.
 * @returns {Boolean} fontsLoaded
 */
export const useFontsLoaded = () => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined' || !document.fonts) {
      setFontsLoaded(true);
      return undefined;
    }

    let isMounted = true;
    document.fonts.ready.then(() => {
      if (isMounted) {
        setFontsLoaded(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return fontsLoaded;
};

export default useFontsLoaded;
